var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-vue',{class:_vm.classes,attrs:{"is-cta":_vm.isCta,"href":_vm.redirectionURL,"use-router":false,"modifiers":_vm.modifiers,"is-block":_vm.isBlock,"copy":_vm.buttonText,"event-category":_vm.eventCategory}})}
var staticRenderFns = []

export { render, staticRenderFns }